import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { Farm } from './farms.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/farms');

export const getFarmsListRequest = actionCreator.async<any, any>('[GET_FARMS]');
export const patchFarm = actionCreator.async<{ data: Partial<Farm>; formName: FormName }, Farm>('PATCH_FARM');
export const changeFarm = actionCreator<string>('CHANGE_FARM');
export const resetFarm = actionCreator<{}>('RESET_FARM');
